import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { AuthService, AuthorizeService, ConfirmModalService, ConfirmPasswordService } from '../services';
import { AraxUser } from '../models/auth/arax-user';
import { AppInjector } from '../../app-injector'; // do not import AppModule here instead - breaks ng test (circular dependency)
import { OutstandingBalanceAlertService } from '../services/outstanding-balance-alert/outstanding-balance-alert.service';
import { ToastrService } from 'ngx-toastr';
import { ReceiverModule } from 'app/shared/models/enum/receiver-module';
import { environment } from 'environments/environment';
import { PBLSetup } from '../models/core/pbl-setup';
import { MandatoryActionTypes } from '../models/core/enums/mandatory_action_types';
import { Router } from '@angular/router';
import { camelCase } from 'lodash';
import { ConfirmOptions } from '../models/confirm-options';
import { CalculateAgeService } from '../services/queryModel/calculate-age';
export class BaseComponent {


    user: AraxUser = null;

    public authService: AuthService;
    private toastrService: ToastrService;
    public permissionItems: string[];
    private _authorizationService: AuthorizeService;
    private _routerPage: Router;
    public confirmPasswordService: ConfirmPasswordService;
    public confirmModalService: ConfirmModalService;

    public printedBy: string = "";
    public dynamicPrintedBy: string = "";


    public currentDate: Date = new Date();

    public currentTimestamp: Date = new Date();

    private stickyToastIds: number[] = [];

    constructor() {
        // Access injector defined in AppInjector to access singleton services
        this._authorizationService = AppInjector.injector.get(AuthorizeService);
        this.authService = AppInjector.injector.get(AuthService);
        this.toastrService = AppInjector.injector.get(ToastrService);
        this.confirmPasswordService = AppInjector.injector.get(ConfirmPasswordService);
        this.confirmModalService = AppInjector.injector.get(ConfirmModalService);


        this.user = this.authService.user;
        this._routerPage = AppInjector.injector.get(Router);

        this.authService.userChanged.subscribe((newUser: AraxUser) => {
            this.user = newUser;
        });

        this.printedBy = this.user ? `&&PRINTED_BY=${this.Rot13Rot5Encode(this.user?.id)}` : '';
        this.dynamicPrintedBy = this.user ? `?PRINTED_BY=${this.Rot13Rot5Encode(this.user?.id)}` : '';

    }

    /**
     * Validate all enabled fields defined within FormGroup
     * it can be used like this:
     * if (!this.form.valid) {
     *      this.validateAllFormFields(this.form);
     *      return;
     *  }
     * @param formGroup - Name of FormGroup
     */
    validateAllFormFields(formGroup: FormGroup | FormArray) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl && control.enabled) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup || control instanceof FormArray) {
                this.validateAllFormFields(control);
            }
        });
    }

    nationalIdIsMandatory(pblSetup: PBLSetup) {
        if (pblSetup.MandatoryNationalIdOrDocumentNumber) {
            switch (pblSetup.MandatoryNationalIdAction) {
                case MandatoryActionTypes.Raise:
                    this.showError("Enter Document ID or National ID");
                    return true;
                case MandatoryActionTypes.Alert:
                    this.showWarning("Enter Document ID or National ID");
                    return false;
            }
        }
        return false;
    }

    showError(error, title = 'Error') {
        error = this.camelizeKeys(error);
        if (error?.status === 404) {
            this.toastrService.error('No Data Found');
            return;
        }
        if (error?.error?.length) {

            if (Array.isArray(error?.error)) {
                error.error = this.camelizeKeys(error.error);
                error.error.forEach(element => {
                    this.toastrService.error(element.errorMessage);

                });
                return;
            } else {
                this.toastrService.error(error?.error ? error?.error : `${error?.statusText}: ${error?.message}`);
                return;
            }
        }
        this.toastrService.error(error.statusText ? error.statusText : error.message ? error.message : error, title);
    }

    showSuccess(message: string) {
        this.toastrService.success(message, 'Success');
    }

    showInformation(message: string) {
        this.toastrService.info(message, 'Info');
    }

    showWarning(message: string) {
        this.toastrService.warning(message, 'Warning');
    }

    showStickyWarning(message: string) {
        const prevWarnings = this.toastrService.toasts.filter(e => e.title === 'Warning');

        for (const prevWarn of prevWarnings) {
            this.toastrService.remove(prevWarn.toastId);
        }

        const toast = this.toastrService.warning(message, 'Warning', { timeOut: 0, extendedTimeOut: 0, tapToDismiss: false });
        this.stickyToastIds.push(toast.toastId);
    }

    clearStickyWarnings() {
        for (const toastId of this.stickyToastIds) {
            this.toastrService.remove(toastId);
        }
        this.stickyToastIds = [];
    }

    /**
     * Show a persistent "outstanding balance" alert when this patient still owes the
     * hospital. Resolved lazily via AppInjector so every station can call it without a
     * constructor change. No-op unless the deployment enabled the feature flag.
     */
    alertOutstandingBalance(patientId: number) {
        AppInjector.injector.get(OutstandingBalanceAlertService).checkAndAlert(patientId);
    }

    validatePermission(permissionName: string): boolean {
        return this._authorizationService.hasPermission(permissionName);
    }

    // calculateAge(patientBirthDate?: Date): string {
    //     debugger;


    //     let patientAge: string;

    //     if (!patientBirthDate) {
    //         return patientAge;
    //     }

    //     this._calculateAgeService.calculateAge(patientBirthDate)
    //     .subscribe(data => {
    //         patientAge =data;
    //     });
    //     return patientAge;
    //     // const birthDate = new Date(patientBirthDate);
    //     // const now = new Date(); 
    //     // let years = now.getFullYear() - birthDate.getFullYear();
    //     // let months = now.getMonth() - birthDate.getMonth();
    //     // let days = now.getDate() - birthDate.getDate();

    //     // if (days < 0) {
    //     //     months -= 1;
    //     //     const previousMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    //     //     days += previousMonth.getDate();
    //     // }

    //     // if (months < 0) {
    //     //     years -= 1;
    //     //     months += 12;
    //     // }

    //     // let ageString = "";

    //     // if (years > 0) {
    //     //     ageString += `${years} ${years > 1 ? "Years" : "Year"} `;
    //     // }

    //     // if (months > 0) {
    //     //     ageString += `${months} ${months > 1 ? "Months" : "Month"} `;
    //     // }

    //     // if (days > 0 || ageString === "") {
    //     //     ageString += `${days} ${days > 1 ? "Days" : "Day"}`;
    //     // }

    //     // return ageString.trim();
    // }

    joinUrl(base: string, path: string): string {
        return `${(base ?? '').replace(/\/+$/, '')}/${(path ?? '').replace(/^\/+/, '')}`;
    }

    openLinkInNewTab(url: string) {
        const link = document.createElement('a');
        link.target = '_blank';
        link.href = url;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

    dwonloadPdf(url, filename) {
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = String(filename);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    reportConstantUrl() {
        return environment.reportViewer;
    }

    crystalReportConstantUrl() {
        return environment.crystalReportViewer;
    }

    reportConstantWithParameterUrl() {
        return environment.reportViewerWithParams;
    }
    appointmentExternalLink() {
        return environment.appointmentURI;
    }
    authorityServiceConstantUrl() {
        return environment.authorityService;
    }

    dynamicFormConstantUrl() {
        return environment.dynamicFormViewer;
    }

    nursingManagementUrl() {
        return environment.nursingManagement;
    }

    operationManagementUrl() {
        return environment.operationManagement;
    }

    SqlBuilderEngineUrl() {
        return environment.sqlBuilderEngine;
    }

    cpoeManagementUrl() {
        return environment.cpoeManagement;
    }

    oncologyManagementUrl() {
        return environment.oncologyManagement;
    }

    IsEClaimIntegrationEnabled() {
        return environment.eClaimIntegration;
    }

    isMediSpanIntegrationEnabled() {
        return environment.mediSpanIntegration;
    }

    isMobileIntegrationEnabled() {
        return environment.mobileIntegrationEnabled;
    }


    workSheetTemplate() {
        return environment.worksheetTemplate;
    }

    enableNotification(): boolean {
        return environment.enableNotification;
    }

    enableOncology(): boolean {
        return environment.enableOncology;
    }
    enableAppointment(): boolean {
        return environment.enableAppointment;
    }
    enableMobile(): boolean {
        return environment.mobileIntegrationEnabled;
    }

    enableOperation(): boolean {
        return environment.enableOperation;
    }

    specimenLISReportURI() {
        return environment.specimenLISReportURI;
    }

    cateringManagementUrl() {
        return environment.cateringManagement;
    }

    resetTime(date: Date): Date {
        if (date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        }
        return null;
    }

    setHoursToAfternoon(date: Date): Date {
        if (date) {
            date.setHours(12, 0, 0, 0);
            return date;
        }
        return null;
    }

    vatIntegrationLink() {
        return environment.VatIntegrationManagement;
    }

    homeCareManagementUrl() {
        return environment.homeCareUrl;
    }

    Rot13Rot5Encode(value: string): string {
        // Simple ROT13+ROT5 cipher (Javascript implementation)
        // Copyright StatiX Industries 2013 (MIT License)

        //This is the alphabet array
        const alphaBetString = "A B C D E F G H I J K L M N O P Q R S T U V W X Y Z a b c d e f g h i j k l m n o p q r s t u v w x y z";
        const alphaBetTable = alphaBetString.split(" ");

        //This is the lookup table/array for the ROT13 characters
        const rot13String = "N O P Q R S T U V W X Y Z A B C D E F G H I J K L M n o p q r s t u v w x y z a b c d e f g h i j k l m";
        const rot13Table = rot13String.split(" ");

        //This is for numbers. Numbers will be passed thru ROT5
        const numberString = "1 2 3 4 5 6 7 8 9 0";
        const numberTable = numberString.split(" ");

        //This is the lookup table of ROT5
        const rot5String = "6 7 8 9 0 1 2 3 4 5";
        const rot5Table = rot5String.split(" ");

        //Here's the table for symbols. Symbols will remain the same
        const symbolString = "~ ` ! @ # $ % ^ & * ( ) _ + - = { } [ ] \\ | ; \' : \" < > ? , . /";
        const symbolTable = symbolString.split(" ");

        //Main function
        let output = "";
        for (let i = 0; i < value.length; i++) { //This is checking for spaces and if yes, add a space to the output
            for (let y = 0; y < numberTable.length; y++) { //This is the ROT5 cipher for numbers
                if (value[i] == numberTable[y]) {
                    output += rot5Table[y];
                }
            }
            for (let x = 0; x < alphaBetTable.length; x++) { //This is the ROT13 cipher for letters
                if (value[i] == alphaBetTable[x]) {
                    output += rot13Table[x];
                }
            }
            for (let w = 0; w < symbolTable.length; w++) {
                if (value[i] == symbolTable[w]) {
                    output += symbolTable[w];
                }
            }
            if (value[i] == " ") {
                output += " ";
            }
        }
        return output; //Ultimately, return the output
    }

    externalUrl(moduleId: number): any | null {

        if (moduleId == ReceiverModule.Appointment) {
            return {
                externalUrl: this.appointmentExternalLink(),
                defaultUrl: ''
            }
        }
        else if (moduleId == ReceiverModule.Emr) {
            return {
                externalUrl: this.cpoeManagementUrl(),
                defaultUrl: 'pages/patient-station/'
            }
        }
        else if (moduleId == ReceiverModule.Nurse) {
            return {
                externalUrl: this.nursingManagementUrl(),
                defaultUrl: '/pages/nurseTimeline/main/'
            }
        }
        else if (moduleId == ReceiverModule.Operation) {
            return {
                externalUrl: this.operationManagementUrl(),
                defaultUrl: ''
            }
        }
        else if (moduleId == ReceiverModule.Oncology) {
            return {
                externalUrl: this.oncologyManagementUrl(),
                defaultUrl: ''
            }
        }
        else if (moduleId == ReceiverModule.HomeCare) {
            return {
                externalUrl: this.homeCareManagementUrl(),
                defaultUrl: '/in-patient-request/'
            }
        }
        return null;
    }

    openFullscreen() {
        var document: any = window.document;
        var Element: any = Element;
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {

            if (document.documentElement.requestFullscreen) {
                /* Standard browsers */
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) {
                /* Internet Explorer */
                document.documentElement.msRequestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                /* Firefox */
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                /* Chrome */
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }

        } else {

            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }

        document.body.classList.toggle('report-full-screen');
    }

    printScreen() {
        window.print();
    }

    fileInfo(file) {
        const name = file?.name || '';
        const [fileName, extention = ''] = name.split(/\.([^.]*)$/);
        return { fileName, extention };
    }

    isEqual(array1, array2) {
        if (array1?.length !== array2?.length) {
            return false;
        }
        for (let i = 0; i < array1.length; i++) {
            if (array2?.indexOf(array1[i]) === -1) {
                return false;
            }
        }
        return true;
    }

    onTogglePage(url) {
        this._routerPage.navigateByUrl(`/pages/${url}`);
    }

    isEmptyOrSpaces(event) {
        return event === null || event?.match(/^ *$/) !== null;
    }

    camelizeKeys(obj) {
        if (Array.isArray(obj)) {
            return obj.map(v => this.camelizeKeys(v));
        } else if (obj != null && obj.constructor === Object) {
            return Object.keys(obj).reduce(
                (result, key) => ({
                    ...result,
                    [camelCase(key)]: this.camelizeKeys(obj[key]),
                }),
                {},
            );
        }
        return obj;
    };

    confirmModal(options?: ConfirmOptions): Promise<boolean> {
        return this.confirmModalService.confirm(options);
    }

    onConfirmPassword(): Promise<boolean> {
        return this.confirmPasswordService.confirm();
    }

    b64toBlob(b64Data, contentType) {
        contentType = contentType || '';
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    handelToggleFullScreen(item: boolean): boolean {
        if (document.body.classList) {
            document.body.classList.toggle('panel-fullscreen');
            return !item;
        }

        return false;
    }

    labReportConstantUrl() {
        return environment.labReportViewer;
    }

    restrictDecimals(value: number, maxDecimals: number): number {
        if (!value) return value;

        const multiplier = Math.pow(10, maxDecimals);
        return Math.round(value * multiplier) / multiplier;
    }

    isNumeric(value: any): boolean {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

}
